export const getNestedValue = (obj: any, path: string) => {
  if (!obj) return undefined;
  return path?.split(".").reduce((acc, part) => (acc ? acc[part] : undefined), obj);
};

export const removePreviewUrl = (data: any, keys: string[]) => {
  if (!data) return data;
  const result = { ...data };

  keys.forEach((key) => {
    if (result[key]) {
      if (typeof result[key] === "object" && result[key].value) {
        result[key] = result[key].value;
      }
    }
  });

  return result;
};

// Utility to extract nested value using dot notation
function getValueByPath(obj: any, path: any) {
  if (!path) return undefined;
  return path.split(".").reduce((acc: any, key: any) => acc && acc[key], obj);
}

// Main function to map API data to form default values
export const extractDefaultValuesFromApi = (apiData: any, formConfig: any) => {
  const defaultValues: any = {};

  formConfig.sections.forEach((section: any) => {
    section.widgets.forEach((widget: any) => {
      const { field, apiField } = widget;
      if (!field) return;
      let value;
      if (apiField) {
        value = getValueByPath(apiData, apiField);
      } else {
        value = apiData[field];
      }
      defaultValues[field] = value !== undefined ? value : "";
    });
  });

  return defaultValues;
};
